import React from 'react';

const DivContainer = ({ style, children }) => (
  <div className={style}>{children}</div>
);

export default DivContainer;